export const set = (key, value) => {
	localStorage.setItem(key, JSON.stringify(value));
};

export const get = (key, defaultValue = null) => {
	const raw = localStorage.getItem(key);
	if (raw === null) return defaultValue;
	try {
		return JSON.parse(raw);
	} catch (e) {
		return raw;
	}
};
